const bundle = {
  close: () => 'Luk',
  error: () => 'Fejl',
  warn: () => 'Advarsel',
  info: () => 'Oplysninger',
  confirmation: () => 'Bekræftelse',
  progressIndeterminate: () => 'I gang',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellem ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Intet matchende afsnit fundet.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Tryk på Enter for at vælge en værdi.',
  indexer_touchInstructionText: () =>
    'Dobbelttryk og hold for at aktivere bevægelsestilstand. Træk derefter op eller ned for at justere værdien.',
  inputPassword_show: () => 'Vis adgangskode',
  inputPassword_hide: () => 'Skjul adgangskode',
  inputPassword_hidden: () => 'Adgangskode skjult',
  formControl_clear: () => 'Ryd',
  formControl_loading: () => 'Indlæser',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumlængden ' + p['MAX_LENGTH'] + ' er overskredet.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tegn tilbage.',
  select_noMatchesFound: () => 'Ingen matchninger blev fundet.',
  select_oneMatchFound: () => 'Én matchning blev fundet',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches fundet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eller flere matches fundet',
  selectMultiple_showSelectedValues: () => 'Vis kun valgte værdier.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' værdier valgt.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Afkrydsningsfelt markeret',
  selector_unselected: () => 'Afkrydsningsfelt ikke markeret',
  userAssistance_learnMore: () => 'Lær mere',
  userAssistance_required: () => 'Påkrævet',
  filePicker_singleFileUploadError: () => 'Upload en fil ad gangen',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan ikke uploade filer af typen ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan ikke uploade filer af typen: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'ukendt',
  filePicker_dropzonePrimaryText: () => 'Træk og slip',
  filePicker_dropzoneSecondaryText: () => 'Vælg en fil, eller slip en her',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vælg eller slip filer her',
  filePicker_addFiles: () => 'Tilføj filer',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Forøg',
  inputNumber_decrease: () => 'Formindsk',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Ingen elementer at vise',
  message_navigationFromMessagesRegion: () =>
    'Åbner meddelelsesområde. Tryk på F6 for at navigere tilbage til tidligere fokuseret element.',
  message_navigationToMessagesRegion: () =>
    'Meddelelsesområde har nye meddelelser. Tryk på F6 for at navigere til det seneste meddelelsesområde.',
  messageToast_allMessagesClosed: () => 'Alle toastmeddelelser er lukket.'
};
export default bundle;
